import * as React from "react";
import { PageTitle } from "../../../components/PageTitle";
import { ReactComponent as AddIcon } from "../../../assets/svg/add-icon.svg";

interface Props {
  setOpen: (open: boolean) => void;
  title?: string;
  buttonLabel?: string;
}

export default function ShortlistsHeader({ setOpen, title = "Shortlists", buttonLabel = "New Shortlist" }: Props) {
  return (
    <div className="mastcontent">
      <div className="flex flex-wrap items-center justify-between gap-3">
        <PageTitle title={title} />
        <button onClick={() => setOpen(true)} type="button" className="shrink-0">
          <div className="flex items-center gap-1 bg-primary text-sm sm:text-base text-white py-2.5 sm:py-3 px-4 sm:px-5 lg:px-10 cursor-pointer rounded-xl focus:outline-none focus:shadow-outline whitespace-nowrap">
            <AddIcon className="mr-1" />
            {buttonLabel}
          </div>
        </button>
      </div>
    </div>
  );
}
